// removed by extract-text-webpack-plugin
module.exports = {"callOut":"callOut__callOut___3KfWa"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/lib/containers/callOut.css
// module id = 1568
// module chunks = 0